import { render, staticRenderFns } from "./NewBuyerDialog.vue?vue&type=template&id=96485cd4&"
import script from "./NewBuyerDialog.vue?vue&type=script&lang=js&"
export * from "./NewBuyerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports